// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('configuration.techniques', {
    url: '/techniques',
    templateUrl: 'main/configuration/techniques/techniques.tpl.html',
    data: { pageTitle: 'Techniques' },
  });
};

angular.module('configuration.techniques', []).config(config);
